module.exports = __webpack_public_path__ + "img/politics.25cf87a8.png";